import type {
  GuidanceTooltipSchemaType,
  Modification,
} from '@carboncopyco/types';
import {
  AddRuleButton,
  RulesManager,
  type RulesManagerProps,
} from '../RulesManager';
import { GuidanceManagerContent } from './GuidanceManagerContent';

type GuidanceModification =
  Modification<GuidanceTooltipSchemaType.guidanceTooltip>;

export interface GuidanceManagerProps
  extends Pick<RulesManagerProps, 'isOpen' | 'onClose'> {
  guidanceTooltipsModifications: GuidanceModification[];
  pageUrl: string;
  startGuidanceTooltipsMode: () => void;
  deleteGuidanceTooltipModification?: (
    guidanceTooltipModification: GuidanceModification
  ) => Promise<unknown>;
  toggleGuidanceTooltipModificationVisibility?: (
    guidanceTooltipModification: Modification<GuidanceTooltipSchemaType.guidanceTooltip>,
    isVisible: boolean
  ) => Promise<unknown>;
  onItemHover: (modification: GuidanceModification) => void;
  onItemUnhover: (modification: GuidanceModification) => void;
  onItemClick: (modification: GuidanceModification) => void;
  onSetGlobal?: (modification: GuidanceModification, isGlobal: boolean) => void;
}

export const GuidanceManager = ({
  isOpen,
  guidanceTooltipsModifications,
  pageUrl,
  onClose,
  startGuidanceTooltipsMode,
  deleteGuidanceTooltipModification,
  toggleGuidanceTooltipModificationVisibility,
  onItemHover,
  onItemUnhover,
  onItemClick,
  onSetGlobal,
}: GuidanceManagerProps) => {
  const showEmptyState = !guidanceTooltipsModifications.length;

  return (
    <RulesManager
      isOpen={isOpen}
      onClose={onClose}
    >
      <RulesManager.Header>
        <RulesManager.Header.Title label="Guided Sandbox" />
        <RulesManager.Header.Action>
          <AddRuleButton onClick={startGuidanceTooltipsMode} />
        </RulesManager.Header.Action>
      </RulesManager.Header>
      {showEmptyState ? (
        <RulesManager.EmptyState>
          <RulesManager.EmptyState.Title label="Add guidance tooltips" />
          <RulesManager.EmptyState.Subtitle
            label="Not sure how it works?"
            linkLabel="Learn more"
            linkUrl="https://help.demostack.com/articles/guided-sandbox"
          />
        </RulesManager.EmptyState>
      ) : (
        <RulesManager.Content>
          <GuidanceManagerContent
            guidanceTooltipsModifications={guidanceTooltipsModifications}
            pageUrl={pageUrl}
            deleteGuidanceTooltipModification={
              deleteGuidanceTooltipModification
            }
            toggleGuidanceTooltipModificationVisibility={
              toggleGuidanceTooltipModificationVisibility
            }
            onItemHover={onItemHover}
            onSetGlobal={onSetGlobal}
            onItemUnhover={onItemUnhover}
            onItemClick={onItemClick}
          />
        </RulesManager.Content>
      )}
    </RulesManager>
  );
};
